import { render, staticRenderFns } from "./LegalRegulationEditCreate.vue?vue&type=template&id=08ff5b64&"
import script from "./LegalRegulationEditCreate.vue?vue&type=script&lang=js&"
export * from "./LegalRegulationEditCreate.vue?vue&type=script&lang=js&"
import style0 from "./LegalRegulationEditCreate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LegalRegulationEditCreate.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./LegalRegulationEditCreate.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./LegalRegulationEditCreate.vue?vue&type=style&index=3&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports